import { DELELevel } from './types';

/**
 * DELE 等级详细描述
 * DELE 使用 CEFR 标准（A1-C2）
 */
export const DELE_LEVEL_DESCRIPTIONS: Record<
  DELELevel,
  {
    name: string;
    nameEs: string;
    cefrEquivalent: string;
    description: string;
    canDo: string[];
    studyHours: string;
  }
> = {
  [DELELevel.C2]: {
    name: '精通级',
    nameEs: 'Maestría',
    cefrEquivalent: 'C2',
    description: '能够自如、准确、流利地运用西班牙语，理解所有文本，包括抽象、复杂或文学性的文本。能够非常自然、精确地表达思想和观点。',
    canDo: [
      '理解几乎所有类型的文本，包括技术性、学术性和文学性作品',
      '轻松阅读复杂的长篇文章和著作',
      '在专业和学术领域进行深入的研究',
      '准确、自然、流利地表达复杂的思想和观点',
      '理解语言中的文化细微差别和隐喻',
    ],
    studyHours: '约 800+ 小时',
  },
  [DELELevel.C1]: {
    name: '高级',
    nameEs: 'Dominio operativo eficaz',
    cefrEquivalent: 'C1',
    description: '能够有效地、灵活地运用西班牙语，在社交、学术和专业场合表现自如。能够理解长而复杂的文本。',
    canDo: [
      '理解长而复杂的文章和著作',
      '流畅地表达思想，无需寻找词汇',
      '在专业和学术场合灵活运用语言',
      '清晰、结构良好地撰写复杂文本',
      '理解复杂对话和讲座的主要观点',
    ],
    studyHours: '约 600-700 小时',
  },
  [DELELevel.B2]: {
    name: '中高级',
    nameEs: 'Avanzado',
    cefrEquivalent: 'B2',
    description: '能够理解复杂文本的主要思想，包括技术性讨论。能够流利、自然地与母语者进行交流。',
    canDo: [
      '理解复杂文本的主要思想',
      '参与专业和技术性讨论',
      '流利地与母语者交流而无需费力',
      '撰写清晰、详细的文章',
      '理解电视节目和电影，无需太多努力',
    ],
    studyHours: '约 450-550 小时',
  },
  [DELELevel.B1]: {
    name: '中级',
    nameEs: 'Intermedio',
    cefrEquivalent: 'B1',
    description: '能够理解简单和标准的西班牙语，在熟悉的领域处理大多数情况。能够表达简单的思想。',
    canDo: [
      '理解日常和工作中的常用表达',
      '处理旅行中的大多数情况',
      '就熟悉的话题进行简单连贯的交流',
      '描述经历、事件、梦想和计划',
      '书写简单的个人和正式信函',
    ],
    studyHours: '约 300-400 小时',
  },
  [DELELevel.A2]: {
    name: '初级偏上',
    nameEs: 'Plataforma',
    cefrEquivalent: 'A2',
    description: '能够理解常用短语和表达，在简单和直接的信息交流中生存。',
    canDo: [
      '理解常用的西班牙语短语',
      '进行简单的购物和点餐',
      '描述自己、家人和周围环境',
      '理解简单的问题和指示',
      '书写简单的留言和短文',
    ],
    studyHours: '约 180-250 小时',
  },
  [DELELevel.A1]: {
    name: '入门',
    nameEs: 'Acceso',
    cefrEquivalent: 'A1',
    description: '能够使用最基本的词汇，进行简单的交流。',
    canDo: [
      '理解和使用熟悉的日常用语',
      '进行简单的自我介绍和问候',
      '询问和提供个人信息',
      '理解简单的指示和问题',
      '书写最简单的文本',
    ],
    studyHours: '约 80-120 小时',
  },
};

/**
 * 获取等级描述
 */
export function getLevelDescription(level: DELELevel) {
  return DELE_LEVEL_DESCRIPTIONS[level];
}

/**
 * 获取下一个等级
 */
export function getNextLevel(currentLevel: DELELevel): DELELevel | null {
  const levels = Object.values(DELELevel);
  const currentIndex = levels.indexOf(currentLevel);
  if (currentIndex < levels.length - 1) {
    return levels[currentIndex + 1];
  }
  return null;
}

/**
 * 比较两个等级
 * 返回 -1 如果 a < b，0 如果 a = b，1 如果 a > b
 */
export function compareLevels(a: DELELevel, b: DELELevel): number {
  const levels = Object.values(DELELevel);
  const indexA = levels.indexOf(a);
  const indexB = levels.indexOf(b);
  return Math.sign(indexA - indexB);
}
